import React, { useEffect } from 'react';
import { Field, useForm } from '@/Framework/UI/Organisms/FinalForm';
import isBoolean from 'lodash/isBoolean';
import Input from '@dealroadshow/uikit/core/components/Input';
import InputTags from '@dealroadshow/uikit/core/components/Input/InputTags';
import { useFormPayloadContext } from '@/finsight/application/PortfolioMonitor/FormPayloadContext';
import {
  CUSIPS_LIST_FORM,
} from './constants';
import { validateCusip, validateName } from './validators';

import styles from './createLists.scss';

interface IProps {
  row: string,
  index: number,
}

const CusipsListItem = ({
  row,
  index,
}: IProps) => {
  const { setPayload } = useFormPayloadContext();
  const cusipListForm = useForm(CUSIPS_LIST_FORM);
  const nameFieldState = cusipListForm.getFieldState(`${ row }.name`);
  const {
    active,
    value,
    modified,
  } = nameFieldState || {};
  const updateValues = (val, field) => {
    cusipListForm.change(`${ row }.${ field }`, val); // changing form should be first
    setPayload((prevState) => {
      if ('lists' in prevState) {
        prevState.lists[index][field] = val;
      } else {
        prevState.lists = [{
          [field]: value,
          priority: index + 1,
        }];
      }

      return prevState;
    });
  };

  useEffect(() => {
    if (!active && modified) {
      updateValues(value, 'name');
    }
  }, [value, active, modified]);

  const onCusipsChange = (val) => {
    updateValues(val, 'positions');
  };

  const validate = (value: string) => validateCusip({
    cusip: value,
    fieldName: `${ row }.cusips`,
  });

  const mapCusipsToTags = (positions) => positions.map(({
    value,
    cusip,
    isValid,
    ...position
  }) => ({
    isValid: isBoolean(isValid) ? isValid : true,
    value: cusip || value,
    ...position,
  }));

  return (
    <>
      <Field
        component={ Input }
        name={ `${ row }.name` }
        placeholder="Name of the list"
        label={ `list name ${ index + 1 }` }
        className={ styles.nameField }
        dataTest="createListNameInput"
        validate={ (v) => validateName(v, `${ row }.name`) }
      />
      <label className={ styles.formLabel }>CUSIPS</label>
      <Field name={ `${ row }.positions` }>
        { ({ input }) => (
          <InputTags
            tags={ mapCusipsToTags(input.value || []) }
            onChange={ onCusipsChange }
            placeholder="Copy and paste your CUSIPs. They may be space or comma separated."
            validate={ validate }
            dataTest="createListCusipsInput"
            containerClassName={ styles.tagsContainer }
            errorMessage={ 'Invalid CUSIPs present. Press \'Continue\' to proceed without them.' }
            autoFocus={ false }
          />
        ) }
      </Field>
    </>
  );
};

export default CusipsListItem;
